module.exports = __webpack_public_path__ + "img/magnifier.c0e9fb0c.svg";